/* global $ */

//import { LOCALE } from './global.js';
import { initHomePage } from './page-home.js';
import { initKeySearch } from './page-key-search.js';
import { initMap } from './ymap.js';
import { setupSiteSearch } from './setupSiteSearch.js';

// DOMの準備が完了したら初期化
let isReady =
  document.readyState === 'complete' ||
  (document.readyState !== 'loading' &&
  !document.documentElement.doScroll);
if (isReady) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}

// 初期化
function init() {
  const html = document.querySelector('html');
	const body = document.body;
	const filename = window.location.href.split('/').pop() 
  if (body.classList.contains('home')) {
    // トップページ
    initHomePage();
  } else if (html.classList.contains('page_key_search')) {
    // 検索ページ
    initKeySearch();
  } else if (filename === 'link') {	
		initMap()
  }

  // サイト内検索
  (() => {
    const $siteSearchInput = $('#site-search > .custom-search > input');
    if ($siteSearchInput) setupSiteSearch($siteSearchInput);
  })();

  // 検索ボックス
  (() => {
    const searchBox = document.getElementById('search-box');
    if (searchBox) prepareSearchBox(searchBox);
  })();
  
  // ハンバーガーメニュー
  hamburgerMenu();
  // サイドメニュー
  sideMenuInsertParentToChild();
  // サイドメニュー子メニューの幅設定
  sideMenuAdjustWidth();
  // メインコンテンツへのページ内アンカー
  toMain();
  // 親テーマ由来の不要な要素の削除
  $('#twentynineteen-print-style-css').remove();

}

// 検索ボックス
function prepareSearchBox(searchBox) {
  const
    $tabs = $('.tabs-view > .tab', searchBox);
  // タブに対象の検索フィールドを紐付け
  $tabs.each((i, tab) => tab.targetField = document.getElementById(tab.dataset.tabTarget));
  // タブをクリックしたら検索フィールド表示切り替え
  $tabs.on('click', e => switchTab(e) );
  $tabs.on('keyup', e => {
    if (e.which === 13) {
      switchTab(e);
    }
    return false;
  });

  function switchTab(e) {
    $tabs.each((i, tab) => {
      if (tab == e.target) {
        tab.classList.add('-current');
        tab.targetField.classList.add('-current');
      } else {
        tab.classList.remove('-current');
        tab.targetField.classList.remove('-current');
      }
    })
    return false;
  }
}

// ハンバーガーメニュー
function hamburgerMenu() {
  $('.global-navigation > .hamburgermenu')
    .on('click', (e) => {
      e.delegateTarget.parentNode.classList.toggle('-opened')
    });
}

// サイドメニューの横幅調整
function sideMenuAdjustWidth() {
  const $list = $('.PartContents > .list');
  // ダミー生成
  $list.append('<li class="page_item -dummy"><a></a></li>');
  const $dummy = $list.find('.-dummy');
  const $dummyAnchor = $dummy.find('a');
  // 最大幅計測
  $list.find('.children').each( (index, children) => {
    // サブメニュー
    let width = 0;
    $(children).children('.page_item').each( (index, page_item) => {
      // リスト項目
      $dummyAnchor.text( $(page_item).children('a').text() );
      width = Math.max( width, Math.ceil($dummyAnchor.width()) );
    });
    $(children).find('.page_item > a').width(width + 5);
  });
}

// サイドメニューの子リストに親項目を挿入
function sideMenuInsertParentToChild() {
  // 子リスト
  $('.PartContents > .list .children').each((index, elm) => {
    const $elm = $(elm);
    const $clone = $elm.parent().clone();
    $clone.removeClass('page_item_has_children current_page_item current_page_ancestor current_page_parent');
    $clone.find('ul').remove();
    // 親のリスト項目をコピーして、自身にコピー
    $elm.prepend($clone);
  });
}

// メインコンテンツへのページ内アンカー
function toMain() {
  $('.to-main').on('click', () => {
    const main = document.getElementById('main');
    if (main) {
      $('html, body').animate({
        scrollTop: main.getBoundingClientRect().top
      }, 100 , 'swing')
    }
    return false;
  });
}

